interface GreetingProps {
  message: string;
  onDismiss: () => void;
}

export function Greeting({ message, onDismiss }: GreetingProps): React.JSX.Element {
  return (
    <div className="widget-greeting" role="status" aria-live="polite">
      <button
        type="button"
        className="widget-greeting-close"
        onClick={onDismiss}
        aria-label="Dismiss greeting"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
        </svg>
      </button>
      <p className="widget-greeting-text">{message}</p>
    </div>
  );
}
